const UPDATE_CHART = (state, payload) => {
    // Assign payload to data
    state.charts = payload
};
const UPDATE_TOP_10_COINS = (state, payload) => {
    state.coins = payload
};
const UPDATE_PROCESSED_SPARKLINE_DATA = (state, payload) => {
    state.processedSparkLineData = payload
};

export default {
    UPDATE_CHART,
    UPDATE_TOP_10_COINS,
    UPDATE_PROCESSED_SPARKLINE_DATA
}


// WEBPACK FOOTER //
// ./src/store/mutations.js